import styled, { css } from 'styled-components';
import { always, cond, propEq } from 'ramda';
import Markdown from 'react-markdown'

import { media } from '../../utils/media';
import { CHART_TITLE_COLOR, WIDE_CHART_BACKGROUND_COLOR, WHITE, GRAY, DUSTY_GRAY } from '../../utils/colors';
import { WIDTH_TYPES, CHART_TYPES, ZINDEX } from '../../utils/constants';
import { ContentContainer, ContentMain, ContentSide } from '../layout/layout.styles';
import {
  CardToggleButton as CardToggleButtonComponent,
  CardContainer as CardContainerComponent,
} from '../cardLeft/cardLeft.styles';
import { Chart } from '../charts/charts.styles';

export const Side = styled(ContentSide)`
  --content-size: 0;

  ${media.tablet`
    --content-size: 40px;
  `}
  ${media.desktop`
    --content-size: 240px;
  `}
`;

export const Note = styled(ContentContainer)``;

export const MarkdownContent = styled(Markdown)`
  p {
    color: ${CHART_TITLE_COLOR};
    font-size: 12px;
    line-height: 1.5em;
    letter-spacing: 0.3px;
  }
  a {
    color: ${({ theme }) => theme.color};
  }
`

export const Content = styled(ContentContainer)`
  display: flex;
  position: relative;
`;

export const CardToggleButton = styled(CardToggleButtonComponent)`
  position: absolute;
  top: 15px;
  left: 10px;
  z-index: ${ZINDEX.CHART_CARD_TOGGLE_BUTTON};

  ${media.tablet`
    position: static;
  `}
`;

export const CardContainer = styled(CardContainerComponent)`
  top: 1px;
  left: 50px;

  ${media.tablet`
    left: 60px;
    top: -14px;
  `}
`;

export const ChartWrapper = styled(ContentMain)`
  position: relative;
  width: 100%;
  min-height: 100px;
`;

export const ChartLoader = styled.div`
  min-height: 200px;
  height: ${({ height }) => height}px;
  width: 100%;
  color: rgb(204, 204, 204);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const chartWidthStyles = cond([
  [
    propEq('chartWidth', WIDTH_TYPES.WIDE),
    always(css`
      background-color: ${WIDE_CHART_BACKGROUND_COLOR};
      padding: 1px 26px 16px 27px;

      ${cond([
        [
          propEq('chartType', CHART_TYPES.MAP),
          always(css`
            padding-bottom: 0;
            background-color: ${WHITE};
          `),
        ],
      ])}

      ${Side} {
        display: none;
      }

      ${Note} {
        padding: 16px 6px 0 6px;
      }

      ${ChartWrapper} {
        margin-left: 0;

        ${media.desktop`
          margin-left: 0;
        `};

        ${media.desktopWide`;
          margin-left: 0;
        `};
      }
    `),
  ],
  [
    propEq('chartWidth', WIDTH_TYPES.SHORT),
    always(css`
      ${Chart} {
        margin-right: 10px;

        ${media.tablet`
          margin-right: 0;
        `}
      }
    `),
  ],
]);

export const Container = styled.div`
  ${chartWidthStyles};
  margin-bottom: 40px;
  flex-direction: column;
  overflow: hidden;

  @media print {
    display: block;
    page-break-inside: avoid;
  }
`;

export const ChartNotes = styled(Markdown)`
  display: flex;
  justify-content: flex-end;
  color: ${DUSTY_GRAY};
  font-size: 14px;
  letter-spacing: -0.2px;
  padding-right: 20px;

  ${media.tablet`
    padding-right: 0;
  `};
`;
